export { default as ProductsElasticSearchContentFiltersSidebar } from './ProductsElasticSearchContentFiltersSidebar';
